import { useState } from 'react';
import Modal from 'react-modal';

import styles from './VideoButton.module.css';

const VideoButton = (props) => {
  const { className, source, link } = props;

  const [showVideo, setShowVideo] = useState(false);

  const onCloseHandler = () => {
    setShowVideo(false);
  };

  const renderSource = () => {
    if (link) {
      return (
        <iframe
          className={styles.youtube}
          src={link}
          title="Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      );
    }

    return (
      <video
        className={styles.video}
        src={source}
        controls
      />
    );
  };

  const renderVideoModal = () => (
    <Modal
      onRequestClose={onCloseHandler}
      className={styles.modal}
      overlayClassName={styles.overlay}
      isOpen={showVideo}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
    >
      <div className={styles.videoWrapper}>          
        <div className={styles.close} onClick={onCloseHandler} />
        {renderSource()}
      </div>
    </Modal>
  );

  return (
    <>
      {renderVideoModal()}
      <button
        className={`${styles.videoButton} ${className}`}
        onClick={() => setShowVideo(true)}
      />
    </>
  );
};

export default VideoButton;
